itsoftApp.createModule("action", ["formsValidation"], function () {
    var blankButton = document.querySelector(".js-blank");

    if (blankButton) {
        var blankInitialized = false;
        var popupBlank = document.querySelector("#popup-blank.js-validation:not(.js-invisible)");

        blankButton.addEventListener("click", function (evt) {
            evt.preventDefault();

            if (popupBlank && !blankInitialized) {
                blankInitialized = true;

                popupBlank.classList.add("js-visible");
                itsoftApp.modules.formsValidation.callback(popupBlank);
            }
        });
    }
});